<div class="pjc-row" [formGroup]="projectItemForm">
  <div class="pjc-radio">
    <input class="with-gap" type="radio" name="primarypo"
      [value]="projectItemForm.controls.id.value"
      [checked]="currentItem == projectItemForm.controls.id.value"
      [attr.disabled]="readOnly ? '' : null"
      (change)="onItemSelectionChange(projectItemForm)"
      id="{{ 'primarypo' + current }}">
    <label attr.for="{{ 'primarypo' + current }}" matTooltip="mark as primary project contact" matTooltipPosition="above"></label>
  </div>
  <div class="pjc-fields">
    <div class="pjc-top-row">
      <mat-form-field appearance="fill" class="pjc-title">
        <mat-label>Project Contact title</mat-label>
        <mat-select formControlName="title">
          <mat-option value="Project Contact title" disabled>Project Contact title</mat-option>
          <mat-option *ngFor="let title of lookup" [value]="title.id">{{ title.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="pjc-name">
        <mat-label>{{ projectItemForm.get('title').value + ' Full Name' }}</mat-label>
        <input matInput formControlName="name" type="text" maxlength="80">
      </mat-form-field>
    </div>

    <div class="pjc-tags-row" *ngIf="projectItemForm.get('title').value == 'Head of Department'">
      <mat-form-field appearance="fill">
        <mat-label>Select department head tags</mat-label>
        <mat-select formControlName="tags" multiple>
          <mat-option *ngFor="let tag of tags" [value]="tag.id">{{ tag.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="pjc-bottom-row">
      <div class="pjc-bottom-spacer"></div>

      <mat-form-field appearance="fill" class="pjc-email">
        <mat-label>{{ projectItemForm.get('title').value + ' Email' }}</mat-label>
        <input matInput formControlName="email" type="email" maxlength="50">
        <mat-error *ngIf="displayMessage.email">{{ displayMessage.email }}</mat-error>
      </mat-form-field>

      <div class="pjc-right-meta">
        <div class="pjc-toggle" *ngIf="showEmailNotification">
          <mat-slide-toggle color="accent" formControlName="emailNotification">
            Email notification
          </mat-slide-toggle>
        </div>

        <mat-form-field appearance="fill" class="pjc-phone">
          <mat-label>{{ projectItemForm.get('title').value + ' Phone number' }}</mat-label>
          <input matInput formControlName="phoneNumber" type="tel" maxlength="20">
        </mat-form-field>

        <div class="pjc-actions" *ngIf="!readOnly">
          <button mat-icon-button *ngIf="current + 1 == count; else elseBlock3"
            (click)="addProjectItem()" matTooltip="add another project contact" matTooltipPosition="below">
            <mat-icon>add</mat-icon>
          </button>
          <ng-template #elseBlock3>
            <button mat-icon-button (click)="removeProjectItem(current)"
              matTooltip="remove project contact" matTooltipPosition="below">
              <mat-icon>remove</mat-icon>
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
